import React from "react"
import Cross from "../icons/Cross"
import { CartButton } from ".."
import { useSliceContext } from "../SliceProvider"
import { Button } from "../ui/base/button"
import { ProductCart } from "@src/lib/cart/cartProductTypes"
import ProductDefault from "@src/public/product_default.png"
import { useProductParams } from "@src/lib/useProductParams"
import DisplayPrice from "../DisplayPrice"

type Props = {
  product: ProductCart
}

const ListCard = ({ product }: Props) => {
  const { cart, checkoutCompleted, setModalView, isReady } = useSliceContext()
  const { productId, quantity, name, isAllowed, image } = product
  const { handleRemove } = useProductParams(product)
  const displayedImage = image || ProductDefault

  return (
    <div className="sl-relative">
      <div className="sl-flex sl-items-start">
        <div className="sl-relative">
          <img
            src={displayedImage}
            alt={name}
            className={`sl-bg-gradient-to-br sl-aspect-square sl-object-cover sl-from-gray-900 sl-to-gray-700 sl-rounded-md sl-col-span-1 sl-w-20 sm:sl-w-24 sl-cursor-pointer ${
              isAllowed === false && "sl-opacity-50"
            }`}
            onClick={() =>
              setModalView({
                name: "PRODUCT_VIEW",
                cross: true,
                params: {
                  product
                }
              })
            }
          />

          {!checkoutCompleted && (
            <div className="sl-absolute sl-bottom-[4px] sl-right-[-124px]">
              <CartButton productId={productId} />
            </div>
          )}
        </div>
        <div className="sl-ml-4 sl-mr-8 sl-mt-1">
          <div className={`${isAllowed === false ? "sl-opacity-50" : ""}`}>
            <p className="sl-text-sm sm:sl-text-base sl-font-medium">
              <span
                className="sl-cursor-pointer sl-mr-1"
                onClick={() =>
                  setModalView({
                    name: "PRODUCT_VIEW",
                    cross: true,
                    params: {
                      product
                    }
                  })
                }
              >
                {name}
              </span>
            </p>
            {checkoutCompleted && (
              <p className="sl-text-muted-foreground sl-text-sm sl-mt-0.5">
                x{quantity}
              </p>
            )}
          </div>
        </div>
      </div>
      {!checkoutCompleted && (
        <div className="sl-absolute sl-top-[-2px] sl-right-[-10px]">
          <Button
            onClick={(e: React.SyntheticEvent) => {
              e.preventDefault()
              handleRemove()
            }}
            variant="ghost"
            disabled={!isReady || cart.length === 1}
            size="icon"
            className="hover:sl-text-red-500"
          >
            <Cross className="sl-w-5 sl-h-5" />
          </Button>
        </div>
      )}
      <div className="sl-absolute sl-bottom-[8px] sl-right-0 sl-flex sl-ml-56">
        <DisplayPrice product={product} />
      </div>
    </div>
  )
}

export default ListCard
